import { SkillStandardResponse } from '@/models/SkillStandardResponse';
import graphqlRequest from '../skillsMasteryRequest';

const GET_STUDENT_SKILL_STANDARDS = `query getStudentSkillStandards($studentId: ID!, $skillId: ID!) {
  getStudentSkillStandards(studentId: $studentId, skillId: $skillId) {
    skill {
      skillId
      skillName
    }
    standards {
      standardId
      description
    }
  }
}`;

export async function getStudentSkillStandards({
  studentId,
  skillId,
}: {
  studentId: string;
  skillId: string;
}): Promise<{ getStudentSkillStandards: SkillStandardResponse[] }> {
  const inputs = {
    studentId,
    skillId,
  };

  return await graphqlRequest(GET_STUDENT_SKILL_STANDARDS, inputs);
}
